import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { AlertService } from './alert.service';
import { ConfirmDialogService } from './confirm-dialog.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private apiUrl = environment.apiEndpoint;

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private confirmDialogService: ConfirmDialogService,
    private utilService: UtilService
  ) {}

  // Update multiple items
  changeItemsStatus(endpoint, items, option, successCallback) {
    const confirmCallback = () => {
      // this._updateItems(endpoint, items, option).subscribe((response) => {
      this._updateItems(endpoint, items, option).subscribe({
        next: () => {
          items
            .filter((item) => item.isSelected)
            .forEach((item) => {
              item.isSelected = false;

              if (typeof item.status === 'string') {
                if (option === 'activate' && item.status === 'inactive') {
                  item.status = 'active';
                } else if (option === 'deactivate' && item.status === 'active') {
                  item.status = 'inactive';
                }
              } else {
                item.status = !item.status;
              }
            });

          this.alertService.open('Items updated');

          this.utilService.restoreListActions();

          return successCallback();
        },
        error: () => {
          // console.log(resp.error);
          this.alertService.open('Error updating the items', 'error');
        },
      });
    };

    if (option === 'deactivate') {
      const options = {
        title: 'DEACTIVATE_ITEMS',
        message: 'SURE_TO_DEACTIVATE_ITEMS',
        confirmCallback: confirmCallback,
      };

      this.confirmDialogService.open(options);
    } else {
      confirmCallback();
    }
  }

  // Delete multiple items
  deleteItems(endpoint, items, successCallback) {
    const confirmCallback = () => {
      // this._updateItems(endpoint, items, 'destroy').subscribe((response) => {
      this._updateItems(endpoint, items, 'destroy').subscribe({
        next: () => {
          this.alertService.open('DELETED_ITEMS');

          this.utilService.restoreListActions();

          return successCallback();
        },
        error: () => {
          // console.log(resp.error);
          this.alertService.open('Error deleting the items', 'error');
        },
      });
    };

    const options = {
      title: 'DELETE_ITEMS',
      message: 'SURE_TO_DELETE_ITEMS',
      reason: 'DELETE_ITEMS_REASON',
      confirmCallback: confirmCallback,
    };

    this.confirmDialogService.open(options);
  }

  // Update one item
  changeItemStatus(endpoint, item, successCallback, params = null) {
    const confirmCallback = () => {
      // this._updateItem(endpoint, item).subscribe((response) => {
      this._updateItem(endpoint, item).subscribe({
        next: (response) => {
          item.status = response.status;
          item.isSelected = false;

          this.utilService.restoreListActions();

          const successMsg = (params && params.successMsg) || 'ITEM_UPDATED';

          this.alertService.open(successMsg);

          return successCallback();
          // this.utilService.changeItemRowStyle(item.id); // put in the component ?? why ?
        },
        error: () => {
          this.alertService.open('Error updating the item', 'error');
        },
      });
    };

    if (item.status !== 'inactive' && item.status) {
      const options = {
        title: (params && params.title) || 'DEACTIVATE_ITEM',
        message: (params && params.message) || 'SURE_TO_DEACTIVATE_ITEM',
        requireConfirmation: (params && params.requireConfirmation) || false,
        confirmCallback: confirmCallback,
      };

      this.confirmDialogService.open(options);
    } else {
      confirmCallback();
    }
  }

  // Delete on item
  deleteItem(endpoint, item, successCallback, params = null) {
    const confirmCallback = (reason) => {
      // this._deleteItem(endpoint, item, reason).subscribe((response) => {
      this._deleteItem(endpoint, item, reason).subscribe({
        next: () => {
          const successMsg = (params && params.successMsg) || 'ITEM_DELETED';

          this.alertService.open(successMsg);

          return successCallback();
        },
        error: (resp) => {
          if (!resp?.error) {
            return this.alertService.open('Error deleting the item', 'error');
          }

          return this.alertService.open(resp.error['error'], 'error');
        },
      });
    };

    const options = {
      title: (params && params.title) || 'DELETE_ITEM',
      message: (params && params.message) || 'SURE_TO_DELETE_ITEM',
      reason: (params && params.reason) || false,
      requireConfirmation: (params && params.requireConfirmation) || false,
      confirmCallback: confirmCallback,
    };

    this.confirmDialogService.open(options);
  }

  private _updateItems(endpoint: string, items, option: string): Observable<any> {
    const itemsSelected = items.filter((item) => item.isSelected).map((item) => item.id);

    let body = {
      option: option,
      ids: itemsSelected,
    };

    return this.http.put<any>(`${this.apiUrl + endpoint}/update_items`, body);

    // Add this to all enpoints if != GET
    /* if (method !== 'get') {
      if (SessionService.isLoggedIn() && SessionService.getSelectedAccountCompany()) {
        // isLoggedIn to prevent not logged users
        params.audit_company_id = SessionService.getSelectedAccountCompany().id;
      }
    } */
  }

  private _updateItem(endpoint, item): Observable<any> {
    let newStatus;

    if (typeof item.status === 'string') {
      newStatus = item.status === 'active' ? 'inactive' : 'active';
    } else {
      newStatus = !item.status; // Boolean
    }

    let body = {
      status: newStatus,
    };

    return this.http.put<any>(`${this.apiUrl + endpoint}/${item.id}`, body);
  }

  private _deleteItem(endpoint, item, reason): Observable<any> {
    let params = new HttpParams().set('reason_status', reason);

    // Needed, the update item does not send the company_id
    // if (params.company_id) {
    //   item.company_id = params.company_id;
    // }

    if (endpoint === 'websites') {
      endpoint = `companies/${item.company_id}/${endpoint}`;
    }

    return this.http.delete<any>(`${this.apiUrl + endpoint}/${item.id}`, {
      params: params,
    });
  }
}
